import { Component, EventEmitter, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Params, Router } from '@angular/router';
import { FunctionsService, HttpService, LocalStorageService, MessageService, SessionService, TableColumns, TableConfiguration, params } from 'brainloper-ui';
import { Activity } from 'app/models2/maintenance/activity';
import { EndpointDictionary } from 'app/utils/endpoints-dictionary';
import { Resources } from 'app/models2/maintenance/resources';
import { CalendarEvent } from 'angular-calendar';
import { Equipment } from 'app/models2/maintenance/equipment';
import { Data } from 'app/models2/commos/base-response-data';

@Component({
  selector: 'app-modal-calendar',
  templateUrl: './modal-calendar.component.html',
  styleUrls: ['./modal-calendar.component.scss']
})
export class ModalCalendarComponent implements OnInit {


  private urlGetDetalleActividad: string = `${EndpointDictionary.Activity.CRUD_ACTIVITY_DATA}`
  private urlGetComboEquipos: string = `${EndpointDictionary.Equipment.EQUIPMENT_COMBO}`
  public urlGetTablaResourcesActivity: string = `${EndpointDictionary.ResourcesActivity.RESOURCES_ACTIVITY_TABLE}`
  public bodyActividades: Activity
  private paramsComboEquipo: Params[] = []
  public inventoryModule: boolean = this.storage.get<boolean>('inventory_module')
  public viewCarousel: boolean = true
  public resources: Array<Resources> = [{ itemName: '' }]

  //Tabla Recursos
  public labels = []
  public reloadResouces = new EventEmitter<any>()
  public paramsResources: params[] = [{ id: 'activityId', value: '0' }]
  public configurationResouces: TableConfiguration = {
    edit: false,
    add: false,
    delete: false,
    selectable: false,
    addPer: false,
    editPer: false,
    primaryKey: 'id',
    print: false,
  };

  public columnsResouces: TableColumns<Resources>[] = [
    {
      ID: 'itemName',
      label: 'Nombre',
      type: 'combo',
      disregardForEdit: true,
      style: {
        textAlign: 'center',
      },
      paramsCombo: {
        selectionField: 'id',
        visibleField: 'name',
        urlParams: [],
        url: `${EndpointDictionary.Item.ITEM_COMBO}`,
      }
    },
    {
      ID: 'unitMeasurement',
      label: 'Unidad',
      type: 'text',
      disregardForAdd: true,
      disregardForEdit: true,
      style: {
        textAlign: 'center',
      },

    },
    {
      ID: 'amount',
      label: 'Cantidad',
      type: 'number',
      style: {
        textAlign: 'center',
        movil: 'no-movil'
      },
    },
    {
      ID: 'costItem',
      label: 'Costo Item',
      type: 'number',
      style: {
        textAlign: 'center',
        movil: 'no-movil'
      },
    },
    {
      ID: 'totalCostItems',
      label: 'Costo Total Item',
      type: 'number',
      style: {
        textAlign: 'center',
        movil: 'no-movil'
      },
    }

  ];

  constructor(
    public dialogRef: MatDialogRef<ModalCalendarComponent>,
    @Inject(MAT_DIALOG_DATA) public data: CalendarEvent,
    private http: HttpService,
    private message: MessageService,
    private functioEter: FunctionsService,
    private router: Router,
    private session: SessionService,
    private storage: LocalStorageService

  ) {
    this.paramsComboEquipo = []
  }

  ngOnInit(): void {
    this.startField()
  }

  async startField() {
    this.message.openLoading('Cargando', 'Cargando informacion')
    this.paramsResources = [{ id: 'activityId', value: this.data.id }]

    let res: Array<Activity> = await this.http.getDataBody(`${this.urlGetDetalleActividad}/${this.data.id}`)
    if (res) {
      this.bodyActividades = res[0]
      this.bodyActividades.lastMttoDate = this.functioEter.dateIso(this.bodyActividades.lastMttoDate)
      this.message.closeLoading()
    }

  }

  async OT() {
    let res: Array<Equipment> = await this.http.getDataBody(`${this.urlGetComboEquipos}`, this.paramsComboEquipo)
    if (res) {
      for (let element of res) {
        if (element.id == this.bodyActividades.equipmentId) {
          var odometro = element.currentOdometer
          var responsable = element.userId
          break;
        }
      }
      this.session.setData('data', { action: 'calendario', body: this.bodyActividades, odometer: odometro, responsibleId: responsable })
      this.router.navigate(["/mantenimiento/orden_trabajo/detalle"])
      this.dialogRef.close()
    }
  }


  validateInventoryModule() {
    if (!this.inventoryModule || this.resources.length <= 0) {
      this.viewCarousel = false
    }
  }

  dataResources($event: Data<Resources[]>) { 
    this.resources = $event.data
    this.validateInventoryModule()
  }

}
